import React, { useState, useEffect } from 'react'
import axios from 'axios'
import config from './config.json'
// import PageTitle from './components/PageTitle'
import AppHeader from './components/AppHeader'
import AppBody from './components/AppBody'
import ProductCallout from './components/ProductCallout'
import getResinousData from './services/resinousData'
import renderSwitch from './components/renderSwitch'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import toastNotify from './services/toastNotify'
import './css/app.css'

export const AppContext = React.createContext()

function App() {
   const [appHeader, setAppHeader] = useState("") // "What type of product would you like to estimate?"
   const [linkGoBackTarget, setLinkGoBackTarget] = useState({ link: "productTypeSelection" })
   const [currentStep, setCurrentStep] = useState({ step: "productTypeSelection" })
   const [navState, setNavState] = useState({ navStep: "Select Applications", allNavSteps: ["Select Applications"] })
   const [productTypeSteps, setProductTypeSteps] = useState(1)
   const [productOptionsSelected, setProductOptionsSelected] = useState({ productOptions: [""] })
   const [productCoverage, setProductCoverage] = useState()
   const [coverageDetails, setCoverageDetails] = useState()
   const [coverageData, setCoverageData] = useState()
   const [stepsCompleted, setStepsCompleted] = useState(["Select Application"])
   const [stepString, setStepString] = useState()
   const [unit, setUnit] = useState("sqft")
   const [calculatedProducts, setCalculatedProducts] = useState([])
   const [availableColors, setAvailableColors] = useState([])
   const [availableLargeColors, setAvailableLargeColors] = useState([])
    const [availableSmallColors, setAvailableSmallColors] = useState([])
    const [availableLargeVaporBanColors, setAvailableLargeVaporBanColors] = useState([])
    const [availableSmallVaporBanColors, setAvailableSmallVaporBanColors] = useState([])
    const [availableLargeVaporBanChipColors, setAvailableLargeVaporBanChipColors] = useState([])
    const [availableSmallVaporBanChipColors, setAvailableSmallVaporBanChipColors] = useState([])
    const [availableLargeMvbColors, setAvailableLargeMvbColors] = useState([])
    const [availableSmallMvbColors, setAvailableSmallMvbColors] = useState([])
    const [availableLargeMvbChipColors, setAvailableLargeMvbChipColors] = useState([])
    const [availableSmallMvbChipColors, setAvailableSmallMvbChipColors] = useState([])
    const [availableLargeChipColors, setAvailableLargeChipColors] = useState([])
    const [availableSmallChipColors, setAvailableSmallChipColors] = useState([])
    const [availableLargeQuartzColors, setAvailableLargeQuartzColors] = useState([])
    const [availableSmallQuartzColors, setAvailableSmallQuartzColors] = useState([])
    const [availableChipColors, setAvailableChipColors] = useState([])
    const [availableQuartzColors, setAvailableQuartzColors] = useState([])
    const [thicknessCoverage, setThicknessCoverage] = useState([]);
   const [selectedChip, setSelectedChip] = useState([])
    const [selectedColor, setSelectedColor] = useState([])
   const [productSelected, setProductSelected] = useState()
   const [loading, setLoading] = useState(true)
    const [chipValue, setChipValue] = useState()
    const [colorSku, setColorSku] = useState()
    const [colorChipSku, setColorChipSku] = useState()
    const [colorChipCoverage, setColorChipCoverage] = useState(0)
    const [colorChipUnitsRequired, setColorChipUnitsRequired] = useState(0)
    const [colorChipActualUnitsRequired, setColorChipActualUnitsRequired] = useState(0)
    const [colorCoverage, setColorCoverage] = useState(0)
   const [colorValue, setColorValue] = useState()
   const [colorImage, setColorImage] = useState()
   const [chipImage, setChipImage] = useState()
   const appStep = currentStep.step
   const metricAreaToImperialArea = 10.7639
    const imperialAreaToMetricArea = 0.092903

    const [iso, setIso] = useState("en")
    const [groutId, setGroutId] = useState("1")
    const [adhesiveId, setAdhesiveId] = useState("2")

   // Data fetching
   const [resinousFloorSystemsData, setResinousFloorSystemsData] = useState([])
   const [resinousWallSystemsData, setResinousWallSystemsData] = useState([])
   const [resinousCoveSystemsData, setResinousCoveSystemsData] = useState([])
   const [resinousSystemTypes, setResinousSystemTypes] = useState([])
   const [resinousTractionAdditives, setResinousTractionAdditives] = useState([])
   const [groutProducts, setGroutProducts] = useState([])
   const [adhesivesProducts, setAdhesivesProducts] = useState([])
    const [underlaymentProducts, setUnderlaymentProducts] = useState([])
    const [underlaymentResults, setUnderlaymentResults] = useState([])
   const [tileThicknesses, setTileThicknesses] = useState([])
   const [jointSizes, setJointSizes] = useState([])
   const [trowelSizes, setTrowelSizes] = useState([])
   const [vaporBarriers, setVaporBarriers] = useState([])
   const [substratePreparations, setSubstratePreparations] = useState([])
   const [resinousApplicationsData, setResinousApplicationsData] = useState([])
    const [apiError, setApiError] = useState()

    let bu = 1;
    let urlPath = window.location.href.toLowerCase();
    
    if (urlPath.indexOf("eu.") > -1 || urlPath.indexOf("europeauthor") > -1 || urlPath.indexOf("sc_site=europe") > -1) {
        bu = 6;
    }
    if (urlPath.indexOf("au.") > -1 || urlPath.indexOf("australiaauthor") > -1 || urlPath.indexOf("sc_site=australia") > -1) {
        bu = 3;
    }

   // Scroll to top of window at every render
   useEffect(() => {
      // Do not scroll to top on detail input screens.
       appStep !== "resinousCoverageDetails" && appStep !== "resinousCoveCoverageDetails" && appStep !== "underlaymentCoverageDetails" &&
      window.scroll({
         top: 0,
         left: 0
      })
   })
   
   // Fetch all product data from API upon App mount
   useEffect(() => {
      axios.all([
         axios.get(config.resinousFloorSystemsEndpoint), // ALL RESINOUS FLOOR SYSTEMS
         axios.get(config.resinousWallSystemsEndpoint), // ALL RESINOUS WALL SYSTEMS
         axios.get(config.resinousCoveSystemsEndpoint), // ALL RESINOUS COVE SYSTEMS
         axios.get(`${config.resinousTractionAdditivesEndpoint}/${bu}/${iso}`), // RESINOUS TRACTION ADDITIVES
          axios.get(`${config.groutEndpoint}/GetProductsByCategorySubCatAndBu/${groutId}/${bu}/${iso}`), // GROUT
          axios.get(`${config.groutEndpoint}/GetProductsByCategorySubCatAndBu/${adhesiveId}/${bu}/${iso}`), // ADHESIVES
          axios.get(`${config.underlaymentEndpoint}/GetUnderlaymentResultsByBuIso/${bu}/${iso}`), // UNDERLAYMENT
         axios.get(config.tileThicknessEndpoint), // TILE THICKNESS
         axios.get(config.jointSizesEndpoint), // JOINT SIZES
         axios.get(config.trowelSizesEndpoint), // TROWEL SIZES
         axios.get(config.vaporBarriersEndpoint), // VAPOR BARRIERS
         axios.get(config.substratePreparationsEndpoint), // SUBSTRATE PREPARATIONS
          axios.get(config.resinousApplicationsEndpoint), // ALL RESINOUS APPLICATIONS (CATEGORIES)
      ])
      // Set all product data in state
         .then(res => { 
         // const message = "Success! Initial data loaded."
         // const type = "success"
         setResinousFloorSystemsData(res[0].data)
         setResinousWallSystemsData(res[1].data)
         setResinousCoveSystemsData(res[2].data)
             setResinousTractionAdditives(res[3].data)
             console.log(res[4].data)
         setGroutProducts(res[4].data)
         setAdhesivesProducts(res[5].data)
         setUnderlaymentProducts(res[6].data)
         setTileThicknesses(res[7].data)
         setJointSizes(res[8].data)
         setTrowelSizes(res[9].data)
         setVaporBarriers(res[10].data)
         setSubstratePreparations(res[11].data) 
         setResinousApplicationsData(res[12].data)
         setLoading(false)
         // toastNotify(message, type)
         })
         .catch(error => {
             setLoading(false)

             if (axios.isCancel(error)) {
                 console.log(error); // Component unmounted, request is cancelled.
             } else {

                 if (error.response) {
                     // The request was made and the server responded with a status code that falls out of the range of 2xx
                     // console.log(error.response.data);
                     // console.log(error.response.status);
                     // console.log(error.response.headers);
                     setApiError(error.response)
                     const message = "An error occurred while loading initial data. Performance may be affected."
                     const type = "error"
                     toastNotify(message, type)

                 } else if (error.request) {
                     // Example: 404; Bad URL structure to LATICRETE API
                     // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js   
                     setApiError(error.request)
                     const message = "An error occurred while loading initial data. Performance may be affected."
                     const type = "error"
                     toastNotify(message, type)

                 } else {
                     // Something happened in setting up the request that triggered an Error
                     setApiError(error.message)
                     const message = "An error occurred while loading initial data. Performance may be affected."
                     const type = "error"
                     toastNotify(message, type)
                 }
             }
         })
   }, [])

   const {
       productTypes,
      resinousFloorSystems,
      resinousWallSystems,
      resinousCoveSystems
   } = getResinousData(resinousFloorSystemsData, resinousWallSystemsData, resinousCoveSystemsData)
   
   // Remove the last selected product option from state of App.
   function productOptionsRemoveLast() {
      productOptionsSelected.productOptions.pop()
      setProductOptionsSelected({ productOptions: productOptionsSelected.productOptions })
   }

   // Maintain context
   const AppContextValue = {
      productTypes,
      resinousApplicationsData,
      setAppHeader,
      linkGoBackTarget,
      setLinkGoBackTarget,
      setCurrentStep,
      currentStep,
      productTypeSteps,
      setProductTypeSteps,
      renderSwitch,
      appStep,
      navState,
      setNavState,
      resinousFloorSystems,
      resinousWallSystems,
      resinousCoveSystems,
      productOptionsSelected,
      setProductOptionsSelected,
      productOptionsRemoveLast,
      stepsCompleted,
      setStepsCompleted,
      coverageDetails,
      setCoverageDetails,
      resinousTractionAdditives,
      setResinousTractionAdditives,
      groutProducts,
      adhesivesProducts,
       underlaymentProducts,
      underlaymentResults,
      tileThicknesses,
      jointSizes,
      trowelSizes,
      calculatedProducts,
      setCalculatedProducts,
      availableLargeColors,
       availableSmallColors,
       availableLargeVaporBanColors,
       availableSmallVaporBanColors,
       availableLargeVaporBanChipColors,
       availableSmallVaporBanChipColors,
       availableLargeMvbColors,
       availableSmallMvbColors,
       availableLargeMvbChipColors,
       availableSmallMvbChipColors,
       availableLargeChipColors,
       availableSmallChipColors,  
       availableLargeQuartzColors,
       availableSmallQuartzColors,  
      availableColors,
      setAvailableLargeColors,
       setAvailableSmallColors,
       setAvailableLargeVaporBanColors,
       setAvailableSmallVaporBanColors,
       setAvailableLargeVaporBanChipColors,
       setAvailableSmallVaporBanChipColors,
       setAvailableLargeMvbColors,
       setAvailableSmallMvbColors,
       setAvailableLargeMvbChipColors,
       setAvailableSmallMvbChipColors, 
       setAvailableLargeChipColors,
       setAvailableSmallChipColors,
       setAvailableLargeQuartzColors,
       setAvailableSmallQuartzColors,
      setAvailableColors,
       availableChipColors,
       setAvailableChipColors,
       availableQuartzColors,
       setAvailableQuartzColors,
      selectedChip,
      setSelectedChip,
      selectedColor,
      setSelectedColor,
      resinousSystemTypes,
      setResinousSystemTypes,
      vaporBarriers,
      setVaporBarriers,
      substratePreparations,
      setSubstratePreparations,
      unit,
      setUnit,
      productCoverage,
      setProductCoverage,
      stepString,
      setStepString,
      coverageData,
      setCoverageData,
      metricAreaToImperialArea,
      imperialAreaToMetricArea,
      productSelected,
      setProductSelected,
      apiError,
      setApiError,
      toastNotify,
      loading,
      setLoading,
      chipValue,
      setChipValue,
      colorValue,
       setColorValue,
       colorSku,
       setColorSku,
       setColorChipSku,
       setColorCoverage,
       colorCoverage,
       setColorChipCoverage,
       colorChipCoverage,
       setColorChipUnitsRequired,
       colorChipUnitsRequired,
       setColorChipActualUnitsRequired,
       colorChipActualUnitsRequired,
      colorChipSku,
      colorImage,
      setColorImage,
      chipImage,
      setChipImage,
       setThicknessCoverage,
       thicknessCoverage,
       bu,
       iso
   }

   return (
      <div className="container app">
         <AppContext.Provider value={ AppContextValue }>
         {/* <PageTitle /> */}
         <AppHeader appHeader={ appHeader } />
         <ProductCallout />
         <AppBody />
         <ToastContainer />
         </AppContext.Provider>
      </div>
   );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js